/**
 * @file 主动延迟相关公共逻辑
 */

import { isMobile } from '@polyv/utils/src/browser';

export default {
  data() {
    return {
      _delayPromise: null,
      _delayReject: null
    };
  },

  props: {
    // 配合视频主动延时(单位毫秒)
    delayTime: {
      type: Number,
    },
  },

  methods: {
    _getUseDelayTime() {
      let useDelayTime;
      if (typeof this._getEntryUseDelayTime === 'function') {
        useDelayTime = this._getEntryUseDelayTime();
      } else {
        useDelayTime = this._getEntryUseDelayTime;
      }
      if (this.checkTime(this.delayTime)) {
        return this.delayTime;
      } else if (this.checkTime(useDelayTime)) {
        return useDelayTime;
      } else {
        return isMobile() ? 8000 : 2000;
      }
    },
    _getDefaultDelayTime() {
      const defaultTime = isMobile() ? 8000 : 2000;
      const useDelayTime = this._getUseDelayTime();
      return (this.checkTime(useDelayTime) ? useDelayTime : defaultTime);
    },
    checkTime(time) {
      return typeof time === 'number' && time >= 0;
    },
    async delay(time) {
      await this.rejectDelay();
      return this.waitDelay(time);
    },

    async waitDelay(time) {
      const defaultDelayTime = this._getDefaultDelayTime();
      // const propsDelayTime = this.delayTime;
      // 判断是否为数字，可以为0。若不为数字则使用默认值。
      // const originDelayTime = typeof propsDelayTime === 'number' ? propsDelayTime : defaultDelayTime;
      const delayTime = this.checkTime(time) ? time : defaultDelayTime;
      this._delayPromise = new Promise((resolve, reject) => {
        this._delayReject = reject;
        setTimeout(() => {
          resolve();
        }, delayTime);
      });
      return this._delayPromise;
    },

    rejectDelay() {
      this._delayPromise && this._delayReject();
      this._delayPromise = null;
    }
  },
};
